<template lang="pug">
  ModalWrapper(
    no-space,
    icon="history",
    :dialog="dialog",
    :max-width="800",
    :header-text="headerText",
    @close="dialog = false;",
  )
    template(
      v-if="dialog",
      v-slot:body="",
    )
      LogTable(
        no-space,
        ref="logViewer",
        :params="params",
      )
</template>

<script>
import Default from '@/layouts/Default.vue';
import ModalWrapper from '@/components/wrapper/ModalWrapper.vue';
import LogTable from '@/components/table/LogTable.vue';

import { capitalizeFirstLetter } from '@/utils/helper';

export default {
  name: 'PopupLogViewer',
  components: {
    ModalWrapper,
    LogTable,
  },

  data: () => ({
    dialog: false,
    params: {},
  }),

  computed: {
    headerText() {
      if (this.params.type && this.params.description) {
        const { type, description } = this.params;

        return `${capitalizeFirstLetter(type)} logs for (${description})`;
      }

      return 'Fetching logs';
    },
  },

  created() {
    window.$eventHub.$on('showPopUpLog', this.showPopUpLog);
  },

  beforeDestroy() {
    window.$eventHub.$off('showPopUpLog', this.showPopUpLog);
  },

  methods: {
    showPopUpLog(params) {
      this.params = params;
      if (this.dialog) {
        this.$nextTick(() => {
          if (this.$refs.logViewer) {
            this.$refs.logViewer.fetch(true);
          }
        });
      } else {
        this.dialog = true;
      }
    },
  },
};
</script>
